import { winnerPageApi } from '../../config';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WinnersPageService {

  constructor(private apiService: ApiService) { }
  getDropdownOptions() {
    return this.apiService.get(`${winnerPageApi.getdropdownOptions}`);
  }
  getquarterlyWinnersData(param){
     return this.apiService.get(`${winnerPageApi.getquarterlyWinnersData}${param}`)
  }
}
